import { cellStyles1 } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';

interface TabScreenMapping {
  [key: string]: string; // Index signature to allow string indexing
}
const experienceConstants = {
  DEFAULT_TABS: [
    { id: '0', index: 0, name: 'Claims Analysis', visibility: true },
    { id: '1', index: 1, name: 'Documents', visibility: true },
    { id: '2', index: 2, name: 'Task Board', visibility: true },
    { id: '3', index: 3, name: 'Risk Stratification', visibility: true },
    { id: '4', index: 4, name: 'Spend Trend', visibility: true },
    { id: '5', index: 5, name: 'Care Gaps', visibility: true },
    { id: '6', index: 6, name: 'Strategy & Insights Board', visibility: true },
    { id: '7', index: 7, name: 'Drafts', visibility: true },
    { id: '8', index: 8, name: 'Proposals', visibility: true },
  ],
  // In core-utils/messages/experienceConstants.ts or within ExperiencePage.tsx
  TAB_SCREEN_MAPPING: {
    'Claims Analysis': 'CLAIM_ANALYSIS',
    Documents: 'DOCUMENTS',
    'Task Board': 'TASK_BOARD',
    'Risk Stratification': 'RISK_STRATIFICATION',
    'Spend Trend': 'SPEND_TREND',
    'Care Gaps': 'CARE_GAPS',
    'Strategy & Insights Board': 'RISK_REGISTER',
    Drafts: 'DRAFT_AGREEMENTS',
    Proposals: 'PROPOSAL_ANALYZER',
  } as TabScreenMapping,
  TITLES: {
    INSIGHTSTITLE: 'Notifications',
    CUSTNOTITITLE: 'Customize Notification',
  },
  INSIGHTS: {
    NEW_RISK_TABLE_COLUMNS: [
      {
        name: 'id',
        cellStyles: cellStyles1,
        align: 'left',
        width: '150px',
      },
      {
        name: 'Insight',
        cellStyles: cellStyles1,
        align: 'left',
        width: '400px',
      },
      {
        name: 'Priority',
        cellStyles: cellStyles1,
        align: 'left',
        width: '125px',
      },
      {
        name: '',
        cellStyles: cellStyles1,
        align: 'left',
        width: '150px',
      },
      {
        name: 'Actions',
        cellStyles: cellStyles1,
        align: 'left',
        width: '150px',
      },
    ],
    SUGGESTED_TABLE_COLUMNS: [
      {
        name: 'id',
        cellStyles: cellStyles1,
        align: 'left',
        width: '150px',
      },
      {
        name: 'Task Name',
        cellStyles: cellStyles1,
        align: 'left',
        width: '1448px',
      },
      {
        name: 'Actions',
        cellStyles: cellStyles1,
        align: 'center',
        width: '400px',
      },
    ],
  },
};

export default experienceConstants;
